import { getActiveTotalCount } from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useQuery } from "react-query";

export default function useGetActiveTotalCount() {
  //Fetching Total Active Count
  return useQuery("GetActiveTotalCount", getActiveTotalCount, {
    refetchOnWindowFocus: false,
  });
}
